import React from 'react';
import loadjs from 'loadjs';
import window from '../../util';
import { Spin } from 'antd';
import { WeaTools } from 'ecCom';
const staticVersion = `?v${WeaTools && WeaTools.ls && WeaTools.ls.getStr("staticVersion") || 0}`;
export const portalFiles = [
    `/spa/portal/public/index.js${staticVersion}`,
    `/spa/portal/public/index.css`,
    `/spa/portal/static/index.js${staticVersion}`,
    `/spa/portal/static/index.css`
];
export interface IPortalPage {
    hpid:number | string;
    formData:{}
}
export default class PortalPage extends React.Component<IPortalPage, any>{
    constructor(props) {
        super(props);
        this.state = { hasLoad: false };
    }
    componentDidMount() {
        const init = () => {
            this.setState({ hasLoad: true });
        }
        loadjs.isDefined('portal') ? loadjs.ready('portal', init) : loadjs(portalFiles, 'portal', {
            async: false,
            success: init
        });
    }
    render() {
        const { hasLoad } = this.state;
        const {hpid,formData} = this.props;
        if (hasLoad) {
            const { Homepage } = window.weaPortal;
            return (<Homepage hpid={hpid} formData={formData}/>);
        } else {
            return (<Spin />);
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/PortalPage.tsx